import BaseForgeCustomizer from '../base-forge';
import ProxyFooter from '../../components/common/ProxyFooter';
import AmplitudeUtils from '../../utils/amplitude-utils';

export default class EnrollQuestionCustomizer extends BaseForgeCustomizer {
  primaryButtonLabel = 'Save';

  async shouldCustomize() {
    return [ 'enroll-question' ].includes(this.context?.controller);
  }

  protected forgifyController() {
    AmplitudeUtils.logMfaEnrollEvent('Question::Landing');
    this.onIdxProceed();
    super.forgifyController();
  }

  protected onIdxProceed() {
    const {
      oktaSignIn: { authClient },
    } = this;
    const originalProceed = authClient.idx.proceed.bind(authClient);
    authClient.idx.proceed = async (...args: any) => {
      const response = await originalProceed.apply(authClient, args);
      if (args[0].step === 'enroll-authenticator' && response.requestDidSucceed) {
        AmplitudeUtils.logMfaEnrollEvent('Question::Success');
      }
      return response;
    };
  }

  protected getFooter({ footerLink }: { footerLink: JQuery }) {
    return (
      <ProxyFooter
        text={this.footerText}
        footerLinks={footerLink.not('[data-se=cancel]')}
        alwaysDisplayBackToSignIn={this.alwaysDisplayBackToLogin}
      />
    );
  }
}
